import { usePageTracking } from '@/lib/usePageTracking'
import { useEventTracking } from '@/lib/useEventTracking'
import '@/shared/styles/global.css'

// Null-render trackers driving the telemetry. Mounted only inside the
// authenticated branch of AuthGuard (below), so tracking runs for signed-in
// sessions only. PageTracker fires a page-view per route change via useLocation;
// EventTracker attaches the document-level [data-track-event] click listener.
export function PageTracker() {
  usePageTracking()
  return null
}

export function EventTracker() {
  useEventTracking()
  return null
}
